import { useGlobalContext } from '@/store/contexts/global-context';
import { AMPLITUDE_EXPERIMENTS, isExperimentEnabled } from '@/utils/experiments';

export const useShowRemindMe = (): boolean => {
    const { experiments, isLoggedIn, isAndroidWrapper } = useGlobalContext();

    return isExperimentEnabled(experiments, AMPLITUDE_EXPERIMENTS.REMIND_ME_WEB) && (isLoggedIn || isAndroidWrapper);
};
